var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Controller, loc } from "../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import ViewFactory from "../view-builder/ViewFactory.js";
import IonResponseHelper from "../ion/IonResponseHelper.js";
import { getV1ClassName } from "../ion/ViewClassNamesFactory.js";
import { TERMINAL_FORMS, ORG_PASSWORD_RECOVERY_LINK, FORMS, FORM_NAME_TO_OPERATION_MAP } from "../ion/RemediationConstants.js";
import transformPayload from "../ion/payloadTransformer.js";
import Util from "../../util/Util.js";
import sessionStorageHelper from "../client/sessionStorageHelper.js";
import { IdxStatus } from "@okta/okta-auth-js";
import { CONFIGURED_FLOW } from "../client/constants.js";
import { ConfigError } from "../../util/Errors.js";
import "cross-fetch";
import "../../../packages/@okta/courage-dist/esm/lib/underscore/underscore-min.js";
import "../../util/BrowserFeatures.js";
import { updateAppState } from "../client/updateAppState.js";
import fn from "../../util/CookieUtil.js";
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var FormController = Controller.extend({
  className: "form-controller",
  appStateEvents: {
    "change:currentFormName": "handleFormNameChange",
    "afterError": "handleAfterError",
    "invokeAction": "handleInvokeAction",
    "saveForm": "handleSaveForm",
    "switchForm": "handleSwitchForm"
  },
  preRender: function() {
    this.removeChildren();
  },
  postRender: function() {
    const currentViewState = this.options.appState.getCurrentViewState();
    if (!currentViewState) {
      return;
    }
    this.clearMetadata();
    let formName = currentViewState.name;
    if (formName === "identify" && this.options.settings.get("flow") === CONFIGURED_FLOW.RESET_PASSWORD) {
      formName = "identify-recovery";
    }
    const TheView = ViewFactory.create(formName, this.options.appState.get("authenticatorKey"));
    try {
      this.formView = this.add(TheView, {
        options: {
          currentViewState
        }
      }).last();
    } catch (error) {
      this.options.settings.callGlobalError(error);
      return;
    }
    this.triggerAfterRenderEvent();
  },
  clearMetadata: function() {
    const formName = this.options.appState.get("currentFormName");
    if (TERMINAL_FORMS.includes(formName)) {
      sessionStorageHelper.removeStateHandle();
    }
  },
  triggerAfterRenderEvent: function() {
    const contextData = this.createAfterEventContext();
    this.trigger("afterRender", contextData);
  },
  handleFormNameChange: function() {
    this.render();
  },
  handleAfterError: function(error) {
    const contextData = this.createAfterEventContext();
    const errorContextData = {
      xhr: error,
      errorSummary: error.responseJSON && error.responseJSON.errorSummary
    };
    this.trigger("afterError", contextData, errorContextData);
  },
  createAfterEventContext: function() {
    const formName = this.options.appState.get("currentFormName");
    const authenticatorKey = this.options.appState.get("authenticatorKey");
    const methodType = this.options.appState.get("authenticatorMethodType");
    const isPasswordRecoveryFlow = this.options.appState.get("isPasswordRecoveryFlow");
    const v1ControllerClassName = getV1ClassName(formName, authenticatorKey, methodType, isPasswordRecoveryFlow);
    const eventData = {
      controller: v1ControllerClassName,
      formName
    };
    if (authenticatorKey) {
      eventData.authenticatorKey = authenticatorKey;
    }
    if (methodType) {
      eventData.methodType = methodType;
    }
    return eventData;
  },
  handleSwitchForm: function(formName) {
    if (this.options.appState.get("messages")) {
      this.options.appState.unset("messages");
    }
    this.options.appState.set("currentFormName", formName);
  },
  // eslint-disable-next-line max-statements
  handleInvokeAction: function() {
    return __async(this, arguments, function* (actionPath = "", actionParams = {}) {
      const {
        appState,
        settings
      } = this.options;
      if (actionPath === ORG_PASSWORD_RECOVERY_LINK && settings.get("oauth2Enabled")) {
        appState.trigger("restartLoginFlow", "resetPassword");
        return;
      }
      const idx = appState.get("idx");
      const {
        stateHandle
      } = idx.context;
      let invokeOptions = {
        exchangeCodeForTokens: false,
        // we handle this in interactionCodeFlow.js
        stateHandle
      };
      let error;
      if (actionPath === "cancel") {
        settings.getAuthClient().transactionManager.clear({
          clearIdxResponse: false
        });
        sessionStorageHelper.removeStateHandle();
        appState.clearAppStateCache();
        appState.unset("lastIdentifier");
        if (settings.get("oauth2Enabled")) {
          appState.trigger("restartLoginFlow");
          return;
        }
      }
      if (FORMS.LAUNCH_AUTHENTICATOR === actionPath && actionParams) {
        invokeOptions = __spreadProps(__spreadValues({}, invokeOptions), {
          actions: [{
            name: actionPath,
            params: actionParams
          }]
        });
      } else if (idx["neededToProceed"].find((item) => item.name === actionPath)) {
        invokeOptions = __spreadProps(__spreadValues({}, invokeOptions), {
          step: actionPath
        });
      } else if (oktaUnderscore.isFunction(idx["actions"][actionPath])) {
        invokeOptions = __spreadProps(__spreadValues({}, invokeOptions), {
          actions: [{
            name: actionPath,
            params: actionParams
          }]
        });
      } else {
        error = new ConfigError(`Invalid action selected: ${actionPath}`);
        this.options.settings.callGlobalError(error);
        yield this.showFormErrors(this.formView.model, error, this.formView.form);
        return;
      }
      yield this.invokeAction(invokeOptions);
    });
  },
  invokeAction: function(invokeOptions) {
    return __async(this, null, function* () {
      const authClient = this.options.settings.getAuthClient();
      let resp;
      let error;
      try {
        resp = yield authClient.idx.proceed(invokeOptions);
        if (resp.requestDidSucceed === false) {
          error = resp;
        }
      } catch (e) {
        error = e;
      }
      if (error) {
        yield this.showFormErrors(this.formView.model, error, this.formView.form);
        return;
      }
      yield this.handleIdxResponse(resp);
    });
  },
  // eslint-disable-next-line max-statements, complexity
  handleSaveForm: function(model) {
    return __async(this, null, function* () {
      const formName = model.get("formName");
      this.toggleFormButtonState(true);
      model.trigger("request");
      if (model.get("useRedirect")) {
        sessionStorageHelper.removeStateHandle();
        if (!Util.isAndroidOVEnrollment()) {
          const currentViewState = this.options.appState.getCurrentViewState();
          Util.executeOnVisiblePage(() => {
            Util.redirectWithFormGet(currentViewState.href);
          });
        }
        return;
      }
      const payload = transformPayload(formName, model);
      const values = this.transformIdentifier(formName, payload);
      if (this.options.settings.get("features.rememberMe")) {
        if (values.identifier) {
          fn.setUsernameCookie(values.identifier);
        }
      } else {
        fn.removeUsernameCookie();
      }
      if (!this.options.appState.hasRemediationObject(formName)) {
        this.options.settings.callGlobalError(`Cannot find http action for "${formName}".`);
        yield this.showFormErrors(this.formView.model, "Cannot find action to proceed.", this.formView.form);
        return;
      }
      if (formName === "identify" && this.options.settings.get("flow") === CONFIGURED_FLOW.RESET_PASSWORD) {
        values.authenticator = "okta_password";
      }
      const authClient = this.options.settings.getAuthClient();
      const idxOptions = {
        exchangeCodeForTokens: false
        // we handle this in interactionCodeFlow.js
      };
      try {
        const idx = this.options.appState.get("idx");
        const {
          stateHandle
        } = idx.context;
        const resp = yield authClient.idx.proceed(__spreadValues(__spreadProps(__spreadValues({}, idxOptions), {
          step: formName,
          stateHandle
        }), values));
        if (resp.status === IdxStatus.FAILURE) {
          throw resp.error;
        }
        if (IonResponseHelper.isIdxSessionExpiredError(resp)) {
          const authClient2 = this.settings.getAuthClient();
          authClient2.transactionManager.clear();
          yield this.handleIdxResponse(resp);
          return;
        }
        if (resp.requestDidSucceed === false && !resp.stepUp) {
          yield this.showFormErrors(model, resp, this.formView.form);
          return;
        }
        const onSuccess = this.handleIdxResponse.bind(this, resp);
        if (formName === FORMS.ENROLL_PROFILE) {
          var _values$userProfile;
          this.settings.postRegistrationSubmit(values === null || values === void 0 ? void 0 : (_values$userProfile = values.userProfile) === null || _values$userProfile === void 0 ? void 0 : _values$userProfile.email, onSuccess, (error) => {
            model.trigger("error", model, {
              responseJSON: error
            });
          });
        } else {
          yield onSuccess();
        }
      } catch (error) {
        var _error$is;
        if ((_error$is = error.is) !== null && _error$is !== void 0 && _error$is.call(error, "terminal")) {
          this.options.appState.setNonIdxError(error);
        } else {
          yield this.showFormErrors(model, error, this.formView.form);
        }
      } finally {
        this.toggleFormButtonState(false);
      }
    });
  },
  transformIdentifier: function(formName, modelJSON) {
    if (Object.prototype.hasOwnProperty.call(modelJSON, "identifier")) {
      const operation = FORM_NAME_TO_OPERATION_MAP[formName];
      modelJSON.identifier = this.settings.transformUsername(modelJSON.identifier, operation);
    }
    return modelJSON;
  },
  /**
   * @param model current form model
   * @param error any errors after user action
   * @param form current form
   * Handle errors that get displayed right after any user action. After such form errors widget doesn't
   * reload or re-render, but updates the AppSate with latest remediation.
   */
  showFormErrors: function(model, error, form) {
    return __async(this, null, function* () {
      var _error;
      const formName = model.get("formName");
      let errorObj;
      let idxStateError;
      let showErrorBanner = true;
      model.trigger("clearFormError");
      if (!error) {
        error = "FormController - unknown error found";
        this.options.settings.callGlobalError(error);
      }
      if ((_error = error) !== null && _error !== void 0 && _error.rawIdxState) {
        idxStateError = error;
        error = error.rawIdxState;
      }
      if (IonResponseHelper.isIonErrorResponse(error)) {
        errorObj = IonResponseHelper.convertFormErrors(error);
      } else if (error.errorSummary) {
        errorObj = {
          responseJSON: error
        };
      } else {
        Util.logConsoleError(error);
        errorObj = {
          responseJSON: {
            errorSummary: loc("error.unsupported.response", "login")
          }
        };
      }
      if (oktaUnderscore.isFunction(form === null || form === void 0 ? void 0 : form.showCustomFormErrorCallout)) {
        var _idxStateError;
        showErrorBanner = !form.showCustomFormErrorCallout(errorObj, (_idxStateError = idxStateError) === null || _idxStateError === void 0 ? void 0 : _idxStateError.messages);
      }
      model.trigger("error", model, errorObj, showErrorBanner);
      idxStateError = Object.assign({}, idxStateError, {
        hasFormError: true
      });
      if (formName === FORMS.IDENTIFY) {
        const identifier = model.get("identifier");
        this.options.appState.set("lastIdentifier", identifier);
      } else {
        this.options.appState.unset("lastIdentifier");
      }
    });
  },
  handleIdxResponse: function(idxResp) {
    return __async(this, null, function* () {
      yield updateAppState(this.options.appState, idxResp);
    });
  },
  /**
   * SignIn widget has its own (hacky) way to customize the button disabled state:
   * adding `link-button-disabled` despite the name was intend only to disable
   * `link-button`.
   * Instead of doing decent refactor, we want to follow the convention for now.
   *
   * @param {boolean} disabled whether add extra disable CSS class.
   */
  toggleFormButtonState: function(disabled) {
    const button = this.$el.find(".o-form-button-bar .button");
    button.toggleClass("link-button-disabled", disabled);
  }
});
export { FormController as default };
